module.exports = __webpack_public_path__ + "img/croix.83d67183.png";